import type { MouseEvent } from "react";

/** Plain left-click (not modifier / middle / right) for tree row links. */
export const isPlainLeftClick = (event: MouseEvent) =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey;
